class ListController {
  /* @ngInject */
  constructor($http, $sce, $state, $stateParams, $window, $scope, Session, urls, SUB_CASE_STATES) {
    this.$http = $http;
    this.$sce = $sce;
    this.$state = $state;
    this.$scope = $scope;
    this.$stateParams = $stateParams;
    this.Session = Session;
    this.SUB_CASE_STATES = SUB_CASE_STATES;
    this.reportListMap = {};
  }

  $onInit() {
    this.searchData = {};
    this.metabaseLink = '';
    this.states = Object.values(this.Session.read('states'));
    this.user = this.Session.read('userinfo') || {};
    this.isVendor = this.user.client.type === 'VENDOR';
    this.params = {
      bucket: this.$stateParams.bucket || (
        this.isVendor ? 'MASTER_TRACKER' : null
      ),
      reportId: this.$stateParams.reportId,
    };

    if (this.isVendor) this.getClientUsers();

    this.$http.get('/case/category', {
      params: {
        allocatedTemplates: true,
      },
    })
      .then(({ data = [] }) => (this.clientCategories = data));

    this.$scope.$on('reportListMap', (evt, data) => {
      this.reportListMap = data;
      this.getReport();
    });
  }

  getClientUsers() {
    this.$http.get('/clientVendor/clientUsers')
      .then(({ data = [] }) => (this.clientUsers = data));
  }

  getCategories() {
    this.categories = this.searchData.clientIds
      .reduce((acc, cl) => acc.concat(
        this.clientCategories.find(clCat => clCat.id === cl).ClientCategories
      ), []);
  }

  getMasterTrackerData() {
    this.showSpinner = true;
    this.$http.get('/case/report/masterTracker', {
      params: {
        clientIds: this.searchData.clientIds
          && (this.searchData.clientIds || []).join(),
        categoryIds: this.searchData.categoryIds
          && (this.searchData.categoryIds || []).join(),
        stateIds: this.searchData.stateIds
          && (this.searchData.stateIds || []).join(),
      },
    })
      .then(({ data: trackerData }) => {
        this.data = trackerData;
      })
      .finally(() => (this.showSpinner = false));
  }

  clearFilters() {
    this.searchData = {};
    this.categories = [];
  }

  getReport() {
    this.metabaseLink = '';

    if (this.params.reportId) {
      const report = this.reportListMap[this.params.reportId];

      if (report) {
        this.showSpinner = true;
        this.name = report.name;

        this
          .$http
          .get(`/report/${this.params.reportId}`)
          .then(({ data }) => {
            this.metabaseLink = data.link;
          });
      } else {
        this.params.bucket = 'MASTER_TRACKER';
        this.params.reportId = null;
        this.name = '';

        this.$state.go('.', this.params, { notify: false });
      }
    } else {
      this.name = '';
    }
  }

  // getReportList() {
  //   this.$http
  //     .get('/report', { params: { clientId: this.$stateParams.id } })
  //     .then(({ data }) => {
  //       this.reportTypes = data;

  //       const keys = Object.keys(data);
  //       this.reportListMap = keys.reduce((acc, curr) => {
  //         data[curr].forEach((x) => {
  //           Object.assign(acc, {
  //             [x.id]: x,
  //           });
  //         });

  //         return acc;
  //       }, {});

  //       this.getReport();
  //     });
  // }

  trustSrc(src) {
    return this.$sce.trustAsResourceUrl(src);
  }

  // goTo(data) {
  //   this.params.bucket = data.bucket;
  //   this.params.reportId = data.reportId;
  //   this.name = data.name;

  //   this.$state.go('.', this.params, { notify: false });

  //   this.getReport();
  // }

  setSpinner(bool) {
    this.$scope.$apply(() => (this.showSpinner = bool));
  }
}

export default ListController;



// WEBPACK FOOTER //
// ./client/app/reports/list/list.controller.js